import React from 'react';

import {Trans} from '../../../../libs/shared/helpers/src/internationalization/react';
import {Handler} from '../../../../libs/shared/helpers/src/react/reactHelpers';
import {OkCancelDialog} from '../../../components/common/dialogs/okCancelDialog';

/*
 * Type.
 */

interface ReportDiscardChangesDialogProps {
  onDiscard: Handler;
  onCancel: Handler;
}

/*
 * Component.
 */

export const ReportDiscardChangesDialog = ({onDiscard, onCancel}: ReportDiscardChangesDialogProps) => (
  <OkCancelDialog
    title={<Trans id="analytics-discard-changes-dialog-title">Unsaved Changes</Trans>}
    okButtonLabel={<Trans id="analytics-discard-changes-dialog-confirm">Discard</Trans>}
    onOkClick={onDiscard}
    onRequestClose={onCancel}
  >
    <Trans id="analytics-discard-changes-dialog-message">
      You have unsaved changes to your filters, continue?
    </Trans>
  </OkCancelDialog>
);
